<template>
  <v-row class="mx-0 grey lighten-3 py-12">
    <v-col cols="12" sm="12" md="12" lg="8" xl="6" offset-lg="2" offset-xl="3">
      <v-card tile elevation="8">
        <v-row class="mx-0">
          <v-col
            cols="12"
            sm="12"
            md="8"
            lg="7"
            xl="8"
            :class="$vuetify.breakpoint.mdAndUp ? 'px-12' : ''"
          >
            <v-card-title primary-title class="py-12">
              <h2 v-html="title"></h2>
            </v-card-title>
            <v-card-text>
              <div v-for="item in array">
                <h2 class="font-italic my-5">{{item.title}}</h2>
                <p
                 align="justify"
                  v-html="item.text"
                  :class="[$vuetify.breakpoint.mdAndUp ? 'headline font-weight-light' : 'subtitle-1 font-weight-regular']"
                ></p>
              </div>
            </v-card-text>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="4"
            lg="5"
            xl="4"
            :class="[$vuetify.breakpoint.mdAndUp ? 'profile-img' : 'profile-img-mobile', imageClass]"
            sty
            :style="{
              backgroundPosition: 'initial',
							backgroundImage:
								'url(' + image + ')'
						}"
          ></v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>
<style>
.profile-img {
  background-size: cover;
  min-height: 50vh;
  background-position: center;
}
.profile-img-mobile {
  background-size: contain;
  height: 200px;
  background-position: center;
}
</style>
<script>
export default {
  props: ["title", "array", "image", "imageClass"],
  data: () => ({
    publicPath: process.env.BASE_URL
  })
};
</script>
